import "./index.css";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/classnames/index.js
var require_classnames = __commonJS({
  "../../node_modules/classnames/index.js"(exports, module) {
    (function() {
      "use strict";
      var hasOwn = {}.hasOwnProperty;
      function classNames2() {
        var classes = "";
        for (var i = 0; i < arguments.length; i++) {
          var arg = arguments[i];
          if (arg) {
            classes = appendClass(classes, parseValue(arg));
          }
        }
        return classes;
      }
      function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") {
          return arg;
        }
        if (typeof arg !== "object") {
          return "";
        }
        if (Array.isArray(arg)) {
          return classNames2.apply(null, arg);
        }
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
          return arg.toString();
        }
        var classes = "";
        for (var key in arg) {
          if (hasOwn.call(arg, key) && arg[key]) {
            classes = appendClass(classes, key);
          }
        }
        return classes;
      }
      function appendClass(value, newClass) {
        if (!newClass) {
          return value;
        }
        if (value) {
          return value + " " + newClass;
        }
        return value + newClass;
      }
      if (typeof module !== "undefined" && module.exports) {
        classNames2.default = classNames2;
        module.exports = classNames2;
      } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) {
        define("classnames", [], function() {
          return classNames2;
        });
      } else {
        window.classNames = classNames2;
      }
    })();
  }
});

// src/MarkdownRenderer/MarkdownRenderer.tsx
import * as React2 from "react";
import Box2 from "@cloudscape-design/components/box";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";

// ../../node_modules/@ungap/structured-clone/esm/types.js
var VOID = -1;
var PRIMITIVE = 0;
var ARRAY = 1;
var OBJECT = 2;
var DATE = 3;
var REGEXP = 4;
var MAP = 5;
var SET = 6;
var ERROR = 7;
var BIGINT = 8;

// ../../node_modules/@ungap/structured-clone/esm/deserialize.js
var env = typeof self === "object" ? self : globalThis;
var deserializer = ($, _) => {
  const as = (out, index) => {
    $.set(index, out);
    return out;
  };
  const unpair = (index) => {
    if ($.has(index))
      return $.get(index);
    const [type, value] = _[index];
    switch (type) {
      case PRIMITIVE:
      case VOID:
        return as(value, index);
      case ARRAY: {
        const arr = as([], index);
        for (const index2 of value)
          arr.push(unpair(index2));
        return arr;
      }
      case OBJECT: {
        const object = as({}, index);
        for (const [key, index2] of value)
          object[unpair(key)] = unpair(index2);
        return object;
      }
      case DATE:
        return as(new Date(value), index);
      case REGEXP: {
        const { source, flags } = value;
        return as(new RegExp(source, flags), index);
      }
      case MAP: {
        const map = as(/* @__PURE__ */ new Map(), index);
        for (const [key, index2] of value)
          map.set(unpair(key), unpair(index2));
        return map;
      }
      case SET: {
        const set = as(/* @__PURE__ */ new Set(), index);
        for (const index2 of value)
          set.add(unpair(index2));
        return set;
      }
      case ERROR: {
        const { name, message } = value;
        return as(new env[name](message), index);
      }
      case BIGINT:
        return as(BigInt(value), index);
      case "BigInt":
        return as(Object(BigInt(value)), index);
      case "ArrayBuffer":
        return as(new Uint8Array(value).buffer, value);
      case "DataView": {
        const { buffer } = new Uint8Array(value);
        return as(new DataView(buffer), value);
      }
    }
    return as(new env[type](value), index);
  };
  return unpair;
};
var deserialize = (serialized) => deserializer(/* @__PURE__ */ new Map(), serialized)(0);

// ../../node_modules/@ungap/structured-clone/esm/serialize.js
var EMPTY = "";
var { toString } = {};
var { keys } = Object;
var typeOf = (value) => {
  const type = typeof value;
  if (type !== "object" || !value)
    return [PRIMITIVE, type];
  const asString = toString.call(value).slice(8, -1);
  switch (asString) {
    case "Array":
      return [ARRAY, EMPTY];
    case "Object":
      return [OBJECT, EMPTY];
    case "Date":
      return [DATE, EMPTY];
    case "RegExp":
      return [REGEXP, EMPTY];
    case "Map":
      return [MAP, EMPTY];
    case "Set":
      return [SET, EMPTY];
    case "DataView":
      return [ARRAY, asString];
  }
  if (asString.includes("Array"))
    return [ARRAY, asString];
  if (asString.includes("Error"))
    return [ERROR, asString];
  return [OBJECT, asString];
};
var shouldSkip = ([TYPE, type]) => TYPE === PRIMITIVE && (type === "function" || type === "symbol");
var serializer = (strict, json, $, _) => {
  const as = (out, value) => {
    const index = _.push(out) - 1;
    $.set(value, index);
    return index;
  };
  const pair = (value) => {
    if ($.has(value))
      return $.get(value);
    let [TYPE, type] = typeOf(value);
    switch (TYPE) {
      case PRIMITIVE: {
        let entry = value;
        switch (type) {
          case "bigint":
            TYPE = BIGINT;
            entry = value.toString();
            break;
          case "function":
          case "symbol":
            if (strict)
              throw new TypeError("unable to serialize " + type);
            entry = null;
            break;
          case "undefined":
            return as([VOID], value);
        }
        return as([TYPE, entry], value);
      }
      case ARRAY: {
        if (type) {
          let spread = value;
          if (type === "DataView") {
            spread = new Uint8Array(value.buffer);
          } else if (type === "ArrayBuffer") {
            spread = new Uint8Array(value);
          }
          return as([type, [...spread]], value);
        }
        const arr = [];
        const index = as([TYPE, arr], value);
        for (const entry of value)
          arr.push(pair(entry));
        return index;
      }
      case OBJECT: {
        if (type) {
          switch (type) {
            case "BigInt":
              return as([type, value.toString()], value);
            case "Boolean":
            case "Number":
            case "String":
              return as([type, value.valueOf()], value);
          }
        }
        if (json && "toJSON" in value)
          return pair(value.toJSON());
        const entries = [];
        const index = as([TYPE, entries], value);
        for (const key of keys(value)) {
          if (strict || !shouldSkip(typeOf(value[key])))
            entries.push([pair(key), pair(value[key])]);
        }
        return index;
      }
      case DATE:
        return as([TYPE, value.toISOString()], value);
      case REGEXP: {
        const { source, flags } = value;
        return as([TYPE, { source, flags }], value);
      }
      case MAP: {
        const entries = [];
        const index = as([TYPE, entries], value);
        for (const [key, entry] of value) {
          if (strict || !(shouldSkip(typeOf(key)) || shouldSkip(typeOf(entry))))
            entries.push([pair(key), pair(entry)]);
        }
        return index;
      }
      case SET: {
        const entries = [];
        const index = as([TYPE, entries], value);
        for (const entry of value) {
          if (strict || !shouldSkip(typeOf(entry)))
            entries.push(pair(entry));
        }
        return index;
      }
    }
    const { message } = value;
    return as([TYPE, { name: type, message }], value);
  };
  return pair;
};
var serialize = (value, { json, lossy } = {}) => {
  const _ = [];
  return serializer(!(json || lossy), !!json, /* @__PURE__ */ new Map(), _)(value), _;
};

// ../../node_modules/@ungap/structured-clone/esm/index.js
var esm_default = typeof structuredClone === "function" ? (
  /* c8 ignore start */
  (any, options) => options && ("json" in options || "lossy" in options) ? deserialize(serialize(any, options)) : structuredClone(any)
) : (any, options) => deserialize(serialize(any, options));

// ../../node_modules/unist-util-position/lib/index.js
var pointEnd = point("end");
var pointStart = point("start");
function point(type) {
  return point2;
  function point2(node) {
    const point3 = node && node.position && node.position[type] || {};
    if (typeof point3.line === "number" && point3.line > 0 && typeof point3.column === "number" && point3.column > 0) {
      return {
        line: point3.line,
        column: point3.column,
        offset: typeof point3.offset === "number" && point3.offset > -1 ? point3.offset : void 0
      };
    }
  }
}
function position(node) {
  const start = pointStart(node);
  const end = pointEnd(node);
  if (start && end) {
    return { start, end };
  }
}

// ../../node_modules/hast-util-sanitize/lib/schema.js
var aria = ["ariaDescribedBy", "ariaLabel", "ariaLabelledBy"];
var defaultSchema = {
  ancestors: {
    tbody: ["table"],
    td: ["table"],
    th: ["table"],
    thead: ["table"],
    tfoot: ["table"],
    tr: ["table"]
  },
  attributes: {
    a: [
      ...aria,
      // Note: these 3 are used by GFM footnotes, they do work on all links.
      "dataFootnoteBackref",
      "dataFootnoteRef",
      ["className", "data-footnote-backref"],
      "href"
    ],
    blockquote: ["cite"],
    // Note: this class is not normally allowed by GH, when manually writing
    // `code` as HTML in markdown, they adds it some other way.
    // We can’t do that, so we have to allow it.
    code: [["className", /^language-./]],
    del: ["cite"],
    div: ["itemScope", "itemType"],
    dl: [...aria],
    // Note: this is used by GFM footnotes.
    h2: [["className", "sr-only"]],
    img: [...aria, "longDesc", "src"],
    // Note: `input` is not normally allowed by GH, when manually writing
    // it in markdown, they add it from tasklists some other way.
    // We can’t do that, so we have to allow it.
    input: [
      ["disabled", true],
      ["type", "checkbox"]
    ],
    ins: ["cite"],
    // Note: this class is not normally allowed by GH, when manually writing
    // `li` as HTML in markdown, they adds it some other way.
    // We can’t do that, so we have to allow it.
    li: [["className", "task-list-item"]],
    // Note: this class is not normally allowed by GH, when manually writing
    // `ol` as HTML in markdown, they adds it some other way.
    // We can’t do that, so we have to allow it.
    ol: [...aria, ["className", "contains-task-list"]],
    q: ["cite"],
    section: ["dataFootnotes", ["className", "footnotes"]],
    source: ["srcSet"],
    summary: [...aria],
    table: [...aria],
    // Note: this class is not normally allowed by GH, when manually writing
    // `ol` as HTML in markdown, they adds it some other way.
    // We can’t do that, so we have to allow it.
    ul: [...aria, ["className", "contains-task-list"]],
    "*": [
      "abbr",
      "accept",
      "acceptCharset",
      "accessKey",
      "action",
      "align",
      "alt",
      "axis",
      "border",
      "cellPadding",
      "cellSpacing",
      "char",
      "charOff",
      "charSet",
      "checked",
      "clear",
      "colSpan",
      "color",
      "cols",
      "compact",
      "coords",
      "dateTime",
      "dir",
      // Note: `disabled` is technically allowed on all elements by GH.
      // But it is useless on everything except `input`.
      // Because `input`s are normally not allowed, but we allow them for
      // checkboxes due to tasklists, we allow `disabled` only there.
      "encType",
      "frame",
      "hSpace",
      "headers",
      "height",
      "hrefLang",
      "htmlFor",
      "id",
      "isMap",
      "itemProp",
      "label",
      "lang",
      "maxLength",
      "media",
      "method",
      "multiple",
      "name",
      "noHref",
      "noShade",
      "noWrap",
      "open",
      "prompt",
      "readOnly",
      "rev",
      "rowSpan",
      "rows",
      "rules",
      "scope",
      "selected",
      "shape",
      "size",
      "span",
      "start",
      "summary",
      "tabIndex",
      "title",
      "useMap",
      "vAlign",
      "value",
      "width"
    ]
  },
  clobber: ["ariaDescribedBy", "ariaLabelledBy", "id", "name"],
  clobberPrefix: "user-content-",
  protocols: {
    cite: ["http", "https"],
    href: ["http", "https", "irc", "ircs", "mailto", "xmpp"],
    longDesc: ["http", "https"],
    src: ["http", "https"]
  },
  required: {
    input: { disabled: true, type: "checkbox" }
  },
  strip: ["script"],
  tagNames: [
    "a",
    "b",
    "blockquote",
    "br",
    "code",
    "dd",
    "del",
    "details",
    "div",
    "dl",
    "dt",
    "em",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "hr",
    "i",
    "img",
    // Note: `input` is not normally allowed by GH, when manually writing
    // it in markdown, they add it from tasklists some other way.
    // We can’t do that, so we have to allow it.
    "input",
    "ins",
    "kbd",
    "li",
    "ol",
    "p",
    "picture",
    "pre",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "section",
    "source",
    "span",
    "strike",
    "strong",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "tr",
    "tt",
    "ul",
    "var"
  ]
};

// ../../node_modules/hast-util-sanitize/lib/index.js
var own = {}.hasOwnProperty;
function sanitize(node, options) {
  let result = { type: "root", children: [] };
  const state = {
    schema: options ? { ...defaultSchema, ...options } : defaultSchema,
    stack: []
  };
  const replace = transform(state, node);
  if (replace) {
    if (Array.isArray(replace)) {
      if (replace.length === 1) {
        result = replace[0];
      } else {
        result.children = replace;
      }
    } else {
      result = replace;
    }
  }
  return result;
}
function transform(state, node) {
  if (node && typeof node === "object") {
    const unsafe = (
      /** @type {Record<string, Readonly<unknown>>} */
      node
    );
    const type = typeof unsafe.type === "string" ? unsafe.type : "";
    switch (type) {
      case "comment": {
        return comment(state, unsafe);
      }
      case "doctype": {
        return doctype(state, unsafe);
      }
      case "element": {
        return element(state, unsafe);
      }
      case "root": {
        return root(state, unsafe);
      }
      case "text": {
        return text(state, unsafe);
      }
      default:
    }
  }
}
function comment(state, unsafe) {
  if (state.schema.allowComments) {
    const result = typeof unsafe.value === "string" ? unsafe.value : "";
    const index = result.indexOf("-->");
    const value = index < 0 ? result : result.slice(0, index);
    const node = { type: "comment", value };
    patch(node, unsafe);
    return node;
  }
}
function doctype(state, unsafe) {
  if (state.schema.allowDoctypes) {
    const node = { type: "doctype" };
    patch(node, unsafe);
    return node;
  }
}
function element(state, unsafe) {
  const name = typeof unsafe.tagName === "string" ? unsafe.tagName : "";
  state.stack.push(name);
  const content = (
    /** @type {Array<ElementContent>} */
    children(state, unsafe.children)
  );
  const properties_ = properties(state, unsafe.properties);
  state.stack.pop();
  let safeElement = false;
  if (name && name !== "*" && (!state.schema.tagNames || state.schema.tagNames.includes(name))) {
    safeElement = true;
    if (state.schema.ancestors && own.call(state.schema.ancestors, name)) {
      const ancestors = state.schema.ancestors[name];
      let index = -1;
      safeElement = false;
      while (++index < ancestors.length) {
        if (state.stack.includes(ancestors[index])) {
          safeElement = true;
        }
      }
    }
  }
  if (!safeElement) {
    return state.schema.strip && !state.schema.strip.includes(name) ? content : void 0;
  }
  const node = {
    type: "element",
    tagName: name,
    properties: properties_,
    children: content
  };
  patch(node, unsafe);
  return node;
}
function root(state, unsafe) {
  const content = (
    /** @type {Array<RootContent>} */
    children(state, unsafe.children)
  );
  const node = { type: "root", children: content };
  patch(node, unsafe);
  return node;
}
function text(_, unsafe) {
  const value = typeof unsafe.value === "string" ? unsafe.value : "";
  const node = { type: "text", value };
  patch(node, unsafe);
  return node;
}
function children(state, children2) {
  const results = [];
  if (Array.isArray(children2)) {
    const childrenUnknown = (
      /** @type {Array<Readonly<unknown>>} */
      children2
    );
    let index = -1;
    while (++index < childrenUnknown.length) {
      const value = transform(state, childrenUnknown[index]);
      if (value) {
        if (Array.isArray(value)) {
          results.push(...value);
        } else {
          results.push(value);
        }
      }
    }
  }
  return results;
}
function properties(state, properties2) {
  const tagName = state.stack[state.stack.length - 1];
  const attributes = state.schema.attributes;
  const required = state.schema.required;
  const specific = attributes && own.call(attributes, tagName) ? attributes[tagName] : void 0;
  const defaults = attributes && own.call(attributes, "*") ? attributes["*"] : void 0;
  const properties_ = (
    /** @type {Readonly<Record<string, Readonly<unknown>>>} */
    properties2 && typeof properties2 === "object" ? properties2 : {}
  );
  const result = {};
  let key;
  for (key in properties_) {
    if (own.call(properties_, key)) {
      const unsafe = properties_[key];
      let safe = propertyValue(
        state,
        findDefinition(specific, key),
        key,
        unsafe
      );
      if (safe === null || safe === void 0) {
        safe = propertyValue(state, findDefinition(defaults, key), key, unsafe);
      }
      if (safe !== null && safe !== void 0) {
        result[key] = safe;
      }
    }
  }
  if (required && own.call(required, tagName)) {
    const properties3 = required[tagName];
    for (key in properties3) {
      if (own.call(properties3, key) && !own.call(result, key)) {
        result[key] = properties3[key];
      }
    }
  }
  return result;
}
function propertyValue(state, definition, key, value) {
  return definition ? Array.isArray(value) ? propertyValueMany(state, definition, key, value) : propertyValuePrimitive(state, definition, key, value) : void 0;
}
function propertyValueMany(state, definition, key, values) {
  let index = -1;
  const result = [];
  while (++index < values.length) {
    const value = propertyValuePrimitive(state, definition, key, values[index]);
    if (typeof value === "number" || typeof value === "string") {
      result.push(value);
    }
  }
  return result;
}
function propertyValuePrimitive(state, definition, key, value) {
  if (typeof value !== "boolean" && typeof value !== "number" && typeof value !== "string") {
    return;
  }
  if (!safeProtocol(state, key, value)) {
    return;
  }
  if (typeof definition === "object" && definition.length > 1) {
    let ok = false;
    let index = 0;
    while (++index < definition.length) {
      const allowed = definition[index];
      if (allowed && typeof allowed === "object" && "flags" in allowed) {
        if (allowed.test(String(value))) {
          ok = true;
          break;
        }
      } else if (allowed === value) {
        ok = true;
        break;
      }
    }
    if (!ok)
      return;
  }
  return state.schema.clobber && state.schema.clobberPrefix && state.schema.clobber.includes(key) ? state.schema.clobberPrefix + value : value;
}
function safeProtocol(state, key, value) {
  const protocols = state.schema.protocols && own.call(state.schema.protocols, key) ? state.schema.protocols[key] : void 0;
  if (!protocols || protocols.length === 0) {
    return true;
  }
  const url = String(value);
  const colon = url.indexOf(":");
  const questionMark = url.indexOf("?");
  const numberSign = url.indexOf("#");
  const slash = url.indexOf("/");
  if (colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
  slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign) {
    return true;
  }
  let index = -1;
  while (++index < protocols.length) {
    const protocol = protocols[index];
    if (colon === protocol.length && url.slice(0, protocol.length) === protocol) {
      return true;
    }
  }
  return false;
}
function patch(node, unsafe) {
  const cleanPosition = position(
    // @ts-expect-error: looks like a node.
    unsafe
  );
  if (unsafe.data) {
    node.data = esm_default(unsafe.data);
  }
  if (cleanPosition)
    node.position = cleanPosition;
}
function findDefinition(definitions, key) {
  let dataDefault;
  let index = -1;
  if (definitions) {
    while (++index < definitions.length) {
      const entry = definitions[index];
      const name = typeof entry === "string" ? entry : entry[0];
      if (name === key) {
        return entry;
      }
      if (name === "data*")
        dataDefault = entry;
    }
  }
  if (key.length > 4 && key.slice(0, 4).toLowerCase() === "data") {
    return dataDefault;
  }
}

// ../../node_modules/rehype-sanitize/lib/index.js
function rehypeSanitize(options) {
  return function(tree) {
    const result = (
      /** @type {Root} */
      sanitize(tree, options)
    );
    return result;
  };
}

// src/MarkdownRenderer/MarkdownRenderer.tsx
var import_classnames = __toESM(require_classnames(), 1);

// src/MarkdownRenderer/preprocessing.ts
var preprocessBulletPoints = (text2) => {
  return text2.replace(/^(\s*)•\s+/gm, "$1- ");
};
var preprocessEmojiLists = (text2) => {
  return text2.replace(/^(\s*)(?:✅|✓|⭐|🔹|▪️|◾|➡️|📌|🎯)\s*/gmu, "$1- ");
};
var ensureBlankLinesBeforeLists = (text2) => {
  const lines = text2.split("\n");
  const result = [];
  for (let i = 0; i < lines.length; i++) {
    const currentLine = lines[i];
    const prevLine = i > 0 ? lines[i - 1] : "";
    const isListItem = /^\s*(\d+\.|-|\*)\s+/.test(currentLine);
    const prevLineNotBlank = prevLine.trim() !== "";
    const prevIsListItem = /^\s*(\d+\.|-|\*)\s+/.test(prevLine);
    if (isListItem && prevLineNotBlank && !prevIsListItem) {
      result.push("");
    }
    result.push(currentLine);
  }
  return result.join("\n");
};
var preprocessMarkdown = (text2) => {
  let processed = text2;
  processed = preprocessBulletPoints(processed);
  processed = preprocessEmojiLists(processed);
  processed = ensureBlankLinesBeforeLists(processed);
  return processed;
};

// src/MarkdownRenderer/components.tsx
import * as React from "react";
import Box from "@cloudscape-design/components/box";
import CopyToClipboard from "@cloudscape-design/components/copy-to-clipboard";
import Header from "@cloudscape-design/components/header";
import Link from "@cloudscape-design/components/link";
import Table from "@cloudscape-design/components/table";
import TextContent from "@cloudscape-design/components/text-content";
import CodeView from "@cloudscape-design/code-view/code-view";
import { MessageRole } from "@amzn/awsmp-max-model";
import { useAppTranslation } from "@amzn/awsmp-max-translations";

// src/MarkdownRenderer/MarkdownRenderer.module.scss
var MarkdownRenderer_module_default = {
  user: "MarkdownRenderer_module_user",
  paragraph: "MarkdownRenderer_module_paragraph",
  link: "MarkdownRenderer_module_link",
  heading1: "MarkdownRenderer_module_heading1",
  heading2: "MarkdownRenderer_module_heading2",
  heading3: "MarkdownRenderer_module_heading3",
  heading4: "MarkdownRenderer_module_heading4",
  list: "MarkdownRenderer_module_list",
  listItem: "MarkdownRenderer_module_listItem",
  blockquote: "MarkdownRenderer_module_blockquote",
  strong: "MarkdownRenderer_module_strong",
  emphasis: "MarkdownRenderer_module_emphasis",
  codeBlock: "MarkdownRenderer_module_codeBlock"
};

// src/MarkdownRenderer/components.tsx
import { Fragment, jsx } from "react/jsx-runtime";
var EMPTY_CELL_PLACEHOLDER = "-";
var TABLE_SECTION_HEAD = "thead";
var TABLE_SECTION_BODY = "tbody";
var COLUMN_ID_PREFIX = "col";
var CODE_BLOCK_MAX_HEIGHT = "200px";
var hasChildren = (props) => props !== null && typeof props === "object" && "children" in props;
var getElementChildren = (el) => {
  const props = el.props;
  if (hasChildren(props)) {
    return props.children;
  }
  return void 0;
};
var flattenCode = (children2) => React.Children.toArray(children2).map((child) => {
  if (typeof child === "string") {
    return child;
  }
  if (React.isValidElement(child)) {
    return flattenCode(getElementChildren(child));
  }
  return "";
}).join("");
var codeToString = (children2) => flattenCode(children2).replace(/\n$/, "");
var CodeBlock = ({ children: children2 }) => {
  const { t } = useAppTranslation();
  const code = codeToString(children2);
  return /* @__PURE__ */ jsx(Box, { margin: { vertical: "xs" }, children: /* @__PURE__ */ jsx("div", { className: MarkdownRenderer_module_default.codeBlock, style: { maxHeight: CODE_BLOCK_MAX_HEIGHT, overflow: "auto" }, children: /* @__PURE__ */ jsx(
    CodeView,
    {
      content: code,
      lineNumbers: true,
      actions: /* @__PURE__ */ jsx(
        CopyToClipboard,
        {
          copyButtonAriaLabel: t("copyCode"),
          copyErrorText: t("copyCodeError"),
          copySuccessText: t("copyCodeSuccess"),
          textToCopy: code
        }
      )
    }
  ) }) });
};
var getMarkdownComponents = (config = {}) => {
  const { processChildren: processChildrenProp, variant } = config;
  const processChildren = processChildrenProp || ((children2) => children2);
  const isUserMessage = variant === MessageRole.User;
  return {
    // Map markdown elements to Cloudscape components
    p: ({ children: children2 }) => /* @__PURE__ */ jsx(TextContent, { className: MarkdownRenderer_module_default.paragraph, children: /* @__PURE__ */ jsx("div", { style: { lineHeight: "1.6" }, children: processChildren(children2) }) }),
    a: ({ href, children: children2 }) => /* @__PURE__ */ jsx(Link, { href, external: true, variant: "primary", className: MarkdownRenderer_module_default.link, children: processChildren(children2) }),
    // `pre` wraps fenced code blocks ONLY (inline code never gets a `pre`), so it is the
    // reliable block-vs-inline discriminator — independent of whether the fence carries a
    // language tag. This also avoids nesting a block-level CodeView inside the default
    // `<pre>`. User messages render the raw code as plain text; everyone else gets a
    // copyable CodeView, so ALL fenced blocks are copyable, not just language-tagged ones.
    pre: ({ children: children2 }) => isUserMessage ? /* @__PURE__ */ jsx(Fragment, { children: children2 }) : /* @__PURE__ */ jsx(CodeBlock, { children: children2 }),
    // Reached for inline code and the inner <code> of a fenced block. The `pre` override
    // above renders the block wrapper (CodeBlock), so this only needs to style inline code.
    // `Box variant="awsui-inline-code"` renders a <code> element with Cloudscape's own
    // inline-code background/padding (themes correctly in light/dark) — preferred over
    // hand-rolled inline styles.
    code: ({ children: children2 }) => {
      if (isUserMessage) {
        return /* @__PURE__ */ jsx(Fragment, { children: processChildren(children2) });
      }
      return /* @__PURE__ */ jsx(Box, { variant: "awsui-inline-code", children: processChildren(children2) });
    },
    h1: ({ children: children2 }) => /* @__PURE__ */ jsx(Box, { margin: { bottom: "s", top: "xs" }, children: /* @__PURE__ */ jsx(Header, { variant: "h1", className: MarkdownRenderer_module_default.heading1, children: processChildren(children2) }) }),
    h2: ({ children: children2 }) => /* @__PURE__ */ jsx(Box, { margin: { bottom: "xs", top: "xxs" }, children: /* @__PURE__ */ jsx(Header, { variant: "h2", className: MarkdownRenderer_module_default.heading2, children: processChildren(children2) }) }),
    h3: ({ children: children2 }) => /* @__PURE__ */ jsx(Box, { margin: { bottom: "xxs", top: "xxs" }, children: /* @__PURE__ */ jsx(Header, { variant: "h3", className: MarkdownRenderer_module_default.heading3, children: processChildren(children2) }) }),
    h4: ({ children: children2 }) => /* @__PURE__ */ jsx(Box, { margin: { bottom: "xxs", top: "xxs" }, children: /* @__PURE__ */ jsx(Header, { variant: "h3", className: MarkdownRenderer_module_default.heading4, children: processChildren(children2) }) }),
    ul: ({ children: children2 }) => /* @__PURE__ */ jsx(Box, { margin: { left: "l", vertical: "xs" }, children: /* @__PURE__ */ jsx("ul", { className: MarkdownRenderer_module_default.list, style: { paddingLeft: "20px" }, children: processChildren(children2) }) }),
    ol: ({ children: children2 }) => /* @__PURE__ */ jsx(Box, { margin: { left: "l", vertical: "xs" }, children: /* @__PURE__ */ jsx("ol", { className: MarkdownRenderer_module_default.list, style: { paddingLeft: "20px" }, children: processChildren(children2) }) }),
    li: ({ children: children2 }) => /* @__PURE__ */ jsx(Box, { margin: { bottom: "xxs" }, children: /* @__PURE__ */ jsx("li", { className: MarkdownRenderer_module_default.listItem, children: processChildren(children2) }) }),
    blockquote: ({ children: children2 }) => /* @__PURE__ */ jsx(Box, { margin: { left: "m", vertical: "xs" }, padding: { left: "m" }, color: "text-body-secondary", children: /* @__PURE__ */ jsx("div", { className: MarkdownRenderer_module_default.blockquote, style: { borderLeft: "2px solid #d1d5db", paddingLeft: "12px" }, children: processChildren(children2) }) }),
    hr: () => /* @__PURE__ */ jsx(Box, { margin: { vertical: "m" }, children: /* @__PURE__ */ jsx("hr", { style: { border: "0", borderTop: "1px solid #e1e4e8" } }) }),
    strong: ({ children: children2 }) => /* @__PURE__ */ jsx("strong", { className: MarkdownRenderer_module_default.strong, children: processChildren(children2) }),
    em: ({ children: children2 }) => /* @__PURE__ */ jsx("em", { className: MarkdownRenderer_module_default.emphasis, children: processChildren(children2) }),
    table: ({ children: children2 }) => {
      const headers = [];
      const rows = [];
      React.Children.forEach(children2, (section) => {
        if (!React.isValidElement(section))
          return;
        const sectionChildren = getElementChildren(section);
        React.Children.forEach(sectionChildren, (row) => {
          if (!React.isValidElement(row))
            return;
          const rowChildren = getElementChildren(row);
          if (section.type === TABLE_SECTION_HEAD) {
            React.Children.forEach(rowChildren, (cell) => {
              if (!React.isValidElement(cell))
                return;
              const cellContent = processChildren(getElementChildren(cell));
              headers.push(cellContent);
            });
          } else if (section.type === TABLE_SECTION_BODY) {
            const rowData = {};
            let colIdx = 0;
            React.Children.forEach(rowChildren, (cell) => {
              if (!React.isValidElement(cell))
                return;
              const cellContent = processChildren(getElementChildren(cell));
              rowData[`${COLUMN_ID_PREFIX}${colIdx}`] = cellContent;
              colIdx++;
            });
            rows.push(rowData);
          }
        });
      });
      const columnDefinitions = headers.map((header, i) => ({
        id: `${COLUMN_ID_PREFIX}${i}`,
        header,
        cell: (item) => item[`${COLUMN_ID_PREFIX}${i}`] ?? EMPTY_CELL_PLACEHOLDER
      }));
      if (headers.length === 0) {
        return null;
      }
      return /* @__PURE__ */ jsx(Box, { margin: { vertical: "m" }, children: /* @__PURE__ */ jsx(
        Table,
        {
          columnDefinitions,
          items: rows,
          enableKeyboardNavigation: true,
          sortingDisabled: true,
          variant: "borderless",
          wrapLines: true,
          resizableColumns: true,
          ariaLabels: { tableLabel: "Data table" }
        }
      ) });
    }
  };
};
var ADDITIONAL_SANITIZED_TAGS = ["thead", "tbody", "tr", "th", "td", "br"];
var getSanitizeSchema = () => ({
  tagNames: [...Object.keys(getMarkdownComponents()), ...ADDITIONAL_SANITIZED_TAGS]
});

// src/MarkdownRenderer/MarkdownRenderer.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var MarkdownRenderer = ({
  children: children2,
  processChildren,
  className,
  variant,
  allowHtml = false,
  allowSanitizedHtml = false
}) => {
  const preprocessedText = React2.useMemo(() => preprocessMarkdown(children2), [children2]);
  const components = React2.useMemo(() => getMarkdownComponents({ processChildren, variant }), [processChildren, variant]);
  const variantClass = variant ? MarkdownRenderer_module_default[variant] : void 0;
  const rehypePlugins = React2.useMemo(() => {
    if (allowSanitizedHtml) {
      return [rehypeRaw, [rehypeSanitize, getSanitizeSchema()]];
    }
    if (allowHtml) {
      return [rehypeRaw];
    }
    return [];
  }, [allowHtml, allowSanitizedHtml]);
  return /* @__PURE__ */ jsx2("div", { className: (0, import_classnames.default)(className, variantClass), children: /* @__PURE__ */ jsx2(Box2, { children: /* @__PURE__ */ jsx2(ReactMarkdown, { remarkPlugins: [remarkGfm], rehypePlugins, components, children: preprocessedText }) }) });
};
export {
  MarkdownRenderer,
  ensureBlankLinesBeforeLists,
  getMarkdownComponents,
  preprocessBulletPoints,
  preprocessEmojiLists,
  preprocessMarkdown
};
/*! Bundled license information:

classnames/index.js:
  (*!
  	Copyright (c) 2018 Jed Watson.
  	Licensed under the MIT License (MIT), see
  	http://jedwatson.github.io/classnames
  *)
*/
//# sourceMappingURL=index.js.map
